module.exports = __webpack_public_path__ + "assets/images/Web-Push.svg";